module.exports = __webpack_public_path__ + "img/179946.4f2ac0b0.png";